export default __webpack_public_path__ + "f0337775c4eed5f21cba5d08c97deec9.png";